// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"dd36852c","453":"b1463420"}[chunkId] + ".chunk.js";
};